import { z } from 'zod';
import { CommunicationTemplateSchema, DocumentTemplateSchema, NoteTemplateSchema, } from '../aggregates/template.js';
const omitProps = {
    reasonForUpdate: true,
    lastUpdated: true,
    createdOn: true,
    modifiedBy: true,
    id: true,
};
export const CreateTemplateApiSchema = {
    body: z.union([
        CommunicationTemplateSchema.omit(omitProps),
        DocumentTemplateSchema.omit(omitProps),
        NoteTemplateSchema.omit(omitProps),
        // TimelineTemplateSchema.omit(omitProps), // breaks open api schema
    ]),
    headers: z.object({
        requestActor: z.string(),
    }),
};
export const CreateTemplateRequestSchema = CreateTemplateApiSchema.body.and(CreateTemplateApiSchema.headers);
